import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';

import { DeviceDetailHeader } from './_layout/-components/DeviceDetailHeader';

export const Route = createFileRoute('/_staff/devices/$id/_layout')({
  component: DeviceDetailLayout,
});

function DeviceDetailHeaderSkeleton() {
  return (
    <div className="border-b border-neutral-border px-12 pt-4 shadow-xs">
      <div className="flex flex-col gap-4">
        <Skeleton className="h-5 w-64" />
        <div className="flex gap-6">
          <Skeleton className="size-[120px] rounded-md" />
          <div className="flex grow flex-col gap-3">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-5 w-32" />
          </div>
        </div>
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
}

function DeviceDetailLayout() {
  return (
    <VStack className="gap-0">
      <Suspense fallback={<DeviceDetailHeaderSkeleton />}>
        <DeviceDetailHeader />
      </Suspense>
      <Outlet />
    </VStack>
  );
}
